import { configHome, DataSource } from "@pub/config";
import placeholders from "@pub/placeholders";
import {
  Ads,
  Card,
  ContentBlock,
  SectionContext,
} from "@sphtech/dmg-design-system";
import cx from "classnames";
import { ReactNode } from "react";

import styles from "../homelayout.module.css";
import { extractHomeContentData, HomeLayoutProps } from "./utils";

type Props = {
  data: HomeLayoutProps["data"];
  dataSource: DataSource;
  alternateBg?: boolean;
  trendingBlock?: boolean;
  scrollable?: boolean;
};

export default function HomeContentBlockN({
  data,
  dataSource,
}: Props): ReactNode {
  const contentBlockN = extractHomeContentData(data, dataSource);
  if (!contentBlockN || contentBlockN.items.length === 0) return null;

  return (
    <div className={cx(styles.bodyContainer, styles.contentHubBlockNContainer)}>
      <ContentBlock
        heading={contentBlockN.title}
        headingZH={contentBlockN.titleZH}
        withDivider={configHome.headingDivider}
        isHeadingClickable={configHome.isHeadingClickable}
        cta={{
          url: contentBlockN.url,
          headingIcon: configHome.viewMore?.icon,
        }}
      >
        <SectionContext.Provider
          value={{
            uniqueName: contentBlockN.uniqSectionName,
          }}
        >
          <div className={cx(styles.cardContainer)}>
            {/* 1st Card */}
            {contentBlockN.items[0] && (
              <div className={styles.firstCard}>
                <Card
                  {...contentBlockN.items[0]}
                  variant="card-stacked-original"
                  mobileUpVariant="card-stacked-portrait-mobile-up"
                  placeholders={placeholders}
                  displayPublishDate={false}
                />
              </div>
            )}

            {/* 2nd to 5th Card */}
            <div className={styles.gridContainer}>
              {contentBlockN.items.slice(1).map((contentBlockItem, index) => {
                return (
                  <Card
                    key={index}
                    {...contentBlockItem}
                    variant="card-stacked-original"
                    mobileUpVariant="card-stacked-portrait-mobile-up"
                    placeholders={placeholders}
                    displayPublishDate={false}
                    // Description and tags are only shown for the 1st Card
                    description={undefined}
                    tags={undefined}
                  />
                );
              })}
            </div>

            <div>
              <Ads.AdsSideBar />
            </div>
          </div>
        </SectionContext.Provider>
      </ContentBlock>
    </div>
  );
}
